import {PortalModule} from '@angular/cdk/portal';
import {CommonModule} from '@angular/common';
import {InjectionToken, ModuleWithProviders, NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatTreeModule} from '@angular/material/tree';
import {RouterModule} from '@angular/router';
import {
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbSelectModule,
  NbTooltipModule
} from '@nebular/theme';
import {TuiAutoFocus} from '@taiga-ui/cdk';
import {TuiIcon} from '@taiga-ui/core';
import {DadataComponent} from './components/dadata/dadata.component';
import {OneDigitDirective} from './directives/OneDigitDirective';
import {PhoneMaskDirective} from './directives/PhoneMaskDirective';
import {RussianPhoneMaskDirective} from './directives/RussianPhoneMaskDirective';
import {Environment} from './interfaces/Environment';
import {MarkupBuilder} from './interfaces/MarkupBuilder';
import {CompoApiService} from './services/compo-api.service';
import {CountDownService} from './services/count-down.service';
import {DecreaseByPercentageStrategy} from './services/strategies/decrease-by-percentage.strategy';
import {DecreaseByValueStrategy} from './services/strategies/decrease-by-value.strategy';
import {IncreaseByPercentageStrategy} from './services/strategies/increase-by-percentage.strategy';
import {IncreaseByValueStrategy} from './services/strategies/increase-by-value.strategy';
import {RestorePriceStrategy} from './services/strategies/restore-price.strategy';
import {translations} from '../../../compob2b-customer/src/environments/translations.ru'

export const MarkupBuilderToken: InjectionToken<MarkupBuilder[]> = new InjectionToken<MarkupBuilder[]>('MarkupBuilder');

/**
 * Creating shared modules allows you to organize and streamline your code.
 * You can put commonly used directives, pipes, and components
 * into one module and then import just that module wherever you need it in other parts of your app.
 * {@link https://angular.io/guide/sharing-ngmodules}
 */
@NgModule({
    exports: [
        RussianPhoneMaskDirective, PhoneMaskDirective, OneDigitDirective,
        DadataComponent,
    ],
    imports: [PortalModule, NbSelectModule, NbInputModule, CommonModule, NbAutocompleteModule, MatTreeModule,
        NbIconModule, NbTooltipModule, RouterModule, MatButtonModule, NbCardModule, NbButtonModule, TuiIcon, TuiAutoFocus, RussianPhoneMaskDirective, PhoneMaskDirective, OneDigitDirective, DadataComponent],
    providers: [CompoApiService, CountDownService,
        { provide: MarkupBuilderToken, useClass: IncreaseByPercentageStrategy, multi: true },
        { provide: MarkupBuilderToken, useClass: DecreaseByPercentageStrategy, multi: true },
        { provide: MarkupBuilderToken, useClass: IncreaseByValueStrategy, multi: true },
        { provide: MarkupBuilderToken, useClass: DecreaseByValueStrategy, multi: true },
        { provide: MarkupBuilderToken, useClass: RestorePriceStrategy, multi: true }
    ]
})
export class SharedModule {

  public static forRoot(environment: Environment): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {provide: environment, useValue: environment},
        {provide: 'environment', useValue: environment},
        {provide: Environment, useValue: environment}
      ]
    };
  }

  public static validationMessages() {
    return [
      {name: 'required', message: translations.requiredValidationMsg},
      {name: 'maxFileSizeExceed', message: 'Превышен максимальный размер файла'},
      {name: 'mimeTypeNotAllowed', message: 'Недопустимый тип файла'},
    ];
  }

}
